import { Group, Box, Grid } from "@mantine/core";
import TextInput from "src/components/TextInput/TextInput";
import Textarea from "src/components/Textarea/Textarea";
import NumberInput from "src/components/NumberInput/NumberInput";
import Switch from "src/components/Switch/Switch";
import { ICreateOrganizationFormProps } from ".";
import { memo, useContext, useEffect, useState } from "react";
import {
  CategoryOptionType,
  useGetCategoryOptionManyLazyQuery,
  useGetPoliciesQuery,
} from "src/generated/graphql";
import { AppContext } from "src/api/AppContext";
import Select, { ISelect } from "src/components/Select";
import MultiSelect from "src/components/MultiSelect";
import ImageUpload from "src/components/ImageUpload";

interface IFormProps {
  isFormActive: boolean;
  form: ICreateOrganizationFormProps;
  isEdit?: boolean;
}
const OrganizationServiceForm = ({
  form,
  isFormActive,
  isEdit = false,
}: IFormProps) => {
  const { currentOrganization } = useContext(AppContext);
  const [getCategories, { data }] = useGetCategoryOptionManyLazyQuery({
    onCompleted(data) {
      let _data = data?.categoryOptionMany;
      let _dataRevenue =
        _data
          ?.filter((e) => e.type === CategoryOptionType.Revenue)
          .map((val) => ({
            value: val.id,
            label: val.name,
          })) || [];
      setrevenueArr(_dataRevenue);

      let _dataService =
        _data
          ?.filter((e) => e.type === CategoryOptionType.Service)
          .map((val) => ({
            value: val.id,
            label: val.name,
          })) || [];
      setserviceArr(_dataService);
    },
  });
  const { data: policiesArr } = useGetPoliciesQuery();
  const [revenueArr, setrevenueArr] = useState<ISelect[]>([]);
  const [serviceArr, setserviceArr] = useState<ISelect[]>([]);
  useEffect(() => {
    if (currentOrganization?.id) {
      getCategories({
        variables: { orgId: currentOrganization?.id || "" },
      });
    }
  }, [currentOrganization]);

  return (
    <>
      <Grid>
        <Grid.Col span={12} md={isEdit ? 5 : 12} mt="xs">
          <ImageUpload
            disabled={isFormActive}
            onReadSuccess={(b64) => form.setFieldValue("imgUrl", b64)}
            src={form.values.imgUrl || ""}
            alt="Service Logo"
            sx={{
              maxHeight: !isEdit ? 180 : "auto",
              maxWidth: !isEdit ? 200 : "auto",
              margin: "auto",
              minHeight: !isEdit ? 180 : 290,
            }}
          />
        </Grid.Col>

        <Grid.Col span={12} md={isEdit ? 7 : 12}>
          <Group sx={{ gap: "14px" }} position="apart" mt="md" mb="md">
            <Switch
              labelPosition="left"
              label="Self-Enroll"
              checked={!!form.getInputProps("isSelfEnroll")?.value}
              {...form.getInputProps("isSelfEnroll")}
              disabled={isFormActive}
            />
            <Switch
              labelPosition="left"
              label="Private Session"
              checked={!!form.getInputProps("isIndivdual")?.value}
              {...form.getInputProps("isIndivdual")}
              disabled={isFormActive}
            />
            <Switch
              labelPosition="left"
              label="Waitlist"
              checked={!!form.getInputProps("isWaitlistEnabled")?.value}
              {...form.getInputProps("isWaitlistEnabled")}
              disabled={isFormActive}
            />
          </Group>

          <TextInput
            withAsterisk
            label="Service Name"
            {...form.getInputProps("name")}
            disabled={isFormActive}
          />

          <Select
            withAsterisk
            data={serviceArr}
            disabled={isFormActive}
            label="Service Type"
            {...form.getInputProps("serviceType")}
          />

          <NumberInput
            withAsterisk
            label="Duration"
            {...form.getInputProps("duration")}
            disabled={isFormActive}
          />

          <Select
            withAsterisk
            data={revenueArr}
            disabled={isFormActive}
            label="Revenue Group"
            {...form.getInputProps("revenueCategory")}
          />

          {form.values.isWaitlistEnabled && (
            <NumberInput
              withAsterisk
              label="Waitlist Max"
              {...form.getInputProps("waitlistMax")}
              disabled={isFormActive}
            />
          )}
        </Grid.Col>
      </Grid>

      <MultiSelect
        disabled={isFormActive}
        data={
          policiesArr?.policyMany?.map((val) => ({
            value: val.id,
            label: val.name,
          })) || []
        }
        label="Select Policies"
        {...form.getInputProps("policies")}
      />

      <Textarea
        label="Description"
        {...form.getInputProps("description")}
        disabled={isFormActive}
        mb={"sm"}
      />
    </>
  );
};

export default memo(OrganizationServiceForm);
